<template>
  <FourElement />
  <div class="collection-container">
    <Filter />
    <List v-if="dataSource && dataSource.length > 0" />
    <div v-if="dataSource && dataSource.length > 0">
      <div class="fs14 lh30 fl" style="color: #999999;">
        {{
          `共 ${pagination.total} 条记录，第${pagination.pageNum} / ${~~(
            pagination.total / pagination.pageSize
          ) +
            (pagination.total % pagination.pageSize
              ? 1
              : pagination.total === 0
              ? 1
              : 0)}页`
        }}
      </div>
      <div
        style="display: flex; flex-direction: row; float: right; padding-bottom: 50px;"
      >
        <a-pagination
          v-if="pagination.pageSize"
          class="mr20"
          v-model:current="pagination.pageNum"
          :total="pagination.total"
          v-model:pageSize="pagination.pageSize"
          :showTotal="() => false"
          :showSizeChanger="false"
          @change="initList"
        />
        <a-select
          class="mr10"
          style="min-width: 80px;"
          v-model:value="pagination.pageSize"
          @change="initList"
          placeholder="条"
          :options="[
            { value: 10, label: 10 },
            { value: 20, label: 20 },
            { value: 30, label: 30 },
            { value: 40, label: 40 },
            { value: 50, label: 50 }
          ]"
        >
        </a-select>
        <div class="lh30 mr10">条/页</div>
        <div class="lh30 mr10">跳转至</div>
        <a-input-number
          class="mr10"
          style="width: 50px;"
          :value="pagination.pageNum"
          placeholder="页"
          :max="
            pagination.total <= pagination.pageSize
              ? 1
              : Math.ceil(pagination.total / pagination.pageSize)
          "
          :min="1"
          @change="watchPage"
        />
        <div class="lh30">页</div>
      </div>
    </div>
  </div>
  <Log />
  <Modal />
</template>
<script>
import { toRefs, reactive, provide, onMounted } from 'vue'
import FourElement from './components/FourElement'
import Filter from './components/Filter'
import List from './components/List'
import Log from './components/Log'
import Modal from './components/Modal'
import useAPI from 'UseApi'
import { message } from 'ant-design-vue'
import { formRequest } from 'cupshe-axios'
const {
  common_querySiteInfo_get_,
  redirectUrl_save_post_,
  redirectUrl_listByCondition_post_,
  redirectUrl_delete_post_,
  redirectUrl_exportData_post_
} = useAPI(null, [3426, 4240, 5922, 8019])
export default {
  components: {
    FourElement,
    Filter,
    List,
    Log,
    Modal
  },
  setup() {
    const state = reactive({
      columns: [
        {
          title: '重定向自',
          dataIndex: 'fromUrl',
          align: 'center'
        },
        {
          title: '重定向至',
          dataIndex: 'toUrl',
          align: 'center'
        },
        {
          title: '场景',
          dataIndex: 'scene',
          align: 'center'
        },
        {
          title: '状态码',
          dataIndex: 'statusCode',
          align: 'center'
        },
        {
          title: '创建人',
          dataIndex: 'creator',
          align: 'center'
        },
        {
          title: '操作',
          slots: { customRender: 'deal' },
          key: 'deal',
          align: 'center',
          width: 200
        }
      ],
      downloadFile: () => {
        redirectUrl_exportData_post_({
          ...state.postParams,
          ...state.searchParams
        })
      },
      importFile: async ({ info }) => {
        const { success, retInfo } = await formRequest(
          `${process.env.VUE_APP_REDIRECTURL}/redirectUrl/importData`,
          {
            file: [info.file],
            ...state.postParams,
            ...state.searchParams
          }
        )
        if (success) {
          message.success(retInfo)
        } else {
          message.error(retInfo)
        }
        state.temList = []
      },
      visible: false,
      visibleChange: (visible = false, text = null) => {
        state.visible = visible
        if (visible && text) {
          state.addParams = { ...text }
        } else {
          state.addParams = {}
        }
      },
      addParams: {
        fromUrl: null,
        toUrl: null,
        scene: null,
        statusCode: null
      },
      addListData: () => {
        let params = {
          ...state.searchParams,
          ...state.addParams
        }
        if (!params.id) {
          delete params.id
        }
        redirectUrl_save_post_(params, state)
      },
      clicked: false,
      hovered: false,
      handleHoverChange: visible => {
        state.clicked = false
        state.hovered = visible
      },
      handleClickChange: visible => {
        state.clicked = visible
        state.hovered = false
      },
      hide: () => {
        state.clicked = false
        state.hovered = false
      },
      watchPage: e => {
        state.pagination.pageNum = e
        state.initList()
      },
      deleteFun: params => {
        redirectUrl_delete_post_(params, state.initList, state)
      },
      value: null,
      dataSource: [],
      searchParams: {
        terminalId: 1,
        brandId: 1,
        channelId: 1,
        siteId: 1
      },
      brands: [],
      channels: [],
      sites: [],
      postParams: {
        scene: null,
        toUrl: null,
        fromUrl: null,
        statusCode: null,
        seoUrl: null,
        timeSet: [],
        name: null, // 标题
        status: -1, // 状态
        colType: -1 // 类型
      },
      resetParams: () => {
        state.postParams = {
          seoUrl: null,
          timeSet: [],
          name: null, // 标题
          colId: null, // 编码
          status: -1 // 状态
        }
        state.initList()
      },
      pagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },
      resetPagination: () => {
        state.pagination = {
          pageNum: 1, // 当前页
          pageSize: 10, // 每页的数量
          total: 0 // 总记录数
        }
        state.initList()
      },
      logList: [],
      logPagination: {
        pageNum: 1, // 当前页
        pageSize: 5, // 每页的数量
        total: 0 // 总记录数
      },
      initList: () => {
        redirectUrl_listByCondition_post_(
          {
            ...state.pagination,
            ...state.postParams,
            ...state.searchParams
          },
          state
        )
      } // 初始化标题列表
    })
    onMounted(() => {
      common_querySiteInfo_get_({
        state
      })
      state.initList()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
